module.exports = __webpack_public_path__ + "static/media/sorting.d632304c.svg";